import router from "@/core/common/router";
import { queryPost } from "@/core/service/api";
import { checkLoginIn } from "../service/api";

const standardtable = {
  namespaced: true,
  name: "login",
  state: {
    code: -1,
    loading: false
  },
  mutations: {
    changeState(state, { payload }) {
      Object.assign(state, payload);
    }
  },
  actions: {
    async loginIn({ commit }, { payload }) {
      commit({
        type: "changeState",
        payload: {
          loading: true
        }
      });
      const response = (await checkLoginIn(payload)) ?? {};
      commit({
        type: "changeState",
        payload: {
          loading: false
        }
      });
      return response;
    },
    async sendCode({ commit }, { payload }) {
      const response = await queryPost(payload, "/api-common-base/sms/validCode/send");
      return response;
    }
  }
};

export default standardtable;
